module.exports = __webpack_public_path__ + "img/add-new.115d7506.svg";